import React from 'react';
import PropTypes from 'prop-types';
import Card from '../Card/Card';
import Notification from '../Notification';

export default function DocumentError({ identifier }) {
  return (
    <Card container className="text-center horizontal-padding">
      <Notification type="error" data-name="error">
        Error Loading Document {identifier}
      </Notification>
    </Card>
  );
}

DocumentError.propTypes = {
  identifier: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/universal/ui/components/Document/DocumentError.js